<template>
  <el-dialog
    :title="isEdit ? '修改账号密码' : '创建账号密码'"
    v-model="dialogVisible"
    width="500px"
    @close="handleCancel"
  >
    <div class="dialog-content">
      <p class="company-name">{{ companyName }}</p>
      
      <el-form :model="formData" label-position="top">
        <el-form-item label="账号" prop="account">
          <el-input 
            v-model="formData.account" 
            placeholder="请输入账号"
            required
          />
        </el-form-item>
        
        <el-form-item label="密码" prop="pwd">
          <el-input 
            type="password" 
            v-model="formData.pwd" 
            :placeholder="`${initialData.pwd || '请输入密码'}`"
            show-password
            required
          />
        </el-form-item>
        
<!--        <el-form-item label="备注" prop="remark">-->
<!--          <el-input -->
<!--            v-model="formData.remark" -->
<!--            placeholder="请输入备注信息" -->
<!--            type="textarea"-->
<!--            :rows="3"-->
<!--          />-->
<!--        </el-form-item>-->
      </el-form>
    </div>
    
    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确定' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { postWlApi } from '@utils/api_v1.js'

const props = defineProps({
  isEdit: {
    type: Boolean,
    default: false
  },
  companyId: {
    type: Number,
    required: true
  },
  companyName: {
    type: String,
    required: true
  },
  initialData: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['close', 'success'])

const formData = reactive({
  account: '',
  pwd: '',
  remark: ''
})

const submitting = ref(false)
const dialogVisible = ref(true)

// 监听initialData变化，更新表单
watch(() => props.initialData, (newData) => {
  if (newData) {
    formData.account = newData.account || ''
    // 不预填密码，保持为空
    formData.pwd = ''
    formData.remark = newData.remark || ''
  }
}, { immediate: true, deep: true })

// 监听dialogVisible变化，当对话框关闭时触发close事件
watch(dialogVisible, (newVal) => {
  if (!newVal) {
    emit('close')
  }
})

const handleCancel = () => {
  dialogVisible.value = false
}

const handleSubmit = async () => {
  // 表单验证
  if (!formData.account.trim() || !formData.pwd.trim()) {
    ElMessage.error('账号和密码不能为空')
    return
  }
  
  submitting.value = true
  
  try {
    const requestData = {
      company_id: props.companyId,
      account: formData.account.trim(),
      pwd: formData.pwd.trim(),
      remark: formData.remark.trim()
    }
    
    let response
    if (props.isEdit) {
      // 修改密码
      response = await postWlApi('/update_password', requestData)
    } else {
      // 创建密码
      response = await postWlApi('/create_password', requestData)
    }
    
    if (response.code === 0) {
      ElMessage.success(props.isEdit ? '密码修改成功' : '密码创建成功')
      emit('success')
    } else {
      ElMessage.error(response.message || (props.isEdit ? '密码修改失败' : '密码创建失败'))
    }
  } catch (error) {
    console.error('操作失败:', error)
    ElMessage.error(props.isEdit ? '密码修改失败' : '密码创建失败')
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.dialog-content {
  padding: 0;
}

.company-name {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
  font-weight: bold;
}
</style>